import { z } from 'zod';
import { adminLocaleSchema } from './locale.js';
export const updateUserSchema = z
    .object({
    active: z.boolean().optional(),
    name: z.string().trim().min(1).max(120).optional(),
})
    .strict();
/** What a person may change about themselves. */
export const updateMeSchema = z
    .object({
    name: z.string().trim().min(1).max(120).optional(),
    locale: adminLocaleSchema.optional(),
})
    .strict();
